<template>
    <div class="pageWrapper">
        <p class="textCenter" style="text-indent: 0;">关于荣耀微信会员的隐私声明</p>
        <p>荣耀微信会员业务是由荣耀终端股份有限公司（以下称“我们”或“荣耀”）运营的为您提供线上门店服务的产品。我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们承诺，将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
        <p>请在使用我们的产品（或服务）前，仔细阅读并了解本《关于荣耀微信会员的隐私声明》。</p>
        <p>您承诺在您开始使用本产品/服务时是成年人。如您是未成年人，则需要您的监护人同意您使用本应用并同意相关应用服务条款。</p>
        <p>如果您有任何疑问、意见或建议，请通过客服热线：400-830-8300 / 800-830-8300（座机）、或通过在线客服与我们联系，或者将其提交至我们的全球办事处。如需获取办事处的完整列表，请访问联系荣耀页面。 </p>
        <p>我们设立了个人信息保护专职部门（或个人信息保护专员），您可以通过访问隐私问题页面与其取得联系。</p>
        <p>一般情况下，我们将在三十日内回复。</p>
        <p>如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过向有管辖权人民法院提起诉讼、向行业自律协会或政府相关管理机构投诉等外部途径进行解决。</p>
        <h6>一、我们如何收集和使用您的个人信息</h6>
        <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
        <p>个人敏感信息是指包括身份证号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。</p>
        <p>我们仅会出于本声明所述的以下目的，收集和使用您的个人信息：</p>
        <h6>（一）为您提供以下核心功能服务</h6>
        <p>1、业务功能一：注册荣耀会员</p>
        <p>为实现注册荣耀会员功能，我们需要收集您的信息：微信头像、微信昵称、手机号码。其中，微信头像、微信昵称是我们通过微信获取的，如您的微信账号绑定了手机号码，我们也会从微信获取您的手机号码。请您仔细阅读该第三方的隐私政策及用户协议。如您拒绝该第三方在提供服务时收集、使用或者传递您的个人信息，将可能导致您无法使用荣耀微信会员相应的服务。若您的微信账号没有绑定手机号码，我们会要求您为我们单独提供您的手机号码。手机号码属于个人敏感信息，收集此类信息的目的是为了确定会员身份以便更好地为您服务。</p>
        <p>我们将按照以下方式使用您的个人信息：在您成功注册会员后，我们会为您生成荣耀会员码。该会员码将显示在您微信卡包中的荣耀会员卡上，并与您的手机号码绑定，方便在您购物或参加活动时为您积分、累积会员成长值。</p>
        <p>2、业务功能而：支付</p>
        <p>在您购买商品时，您可以通过微信支付所提供的支付服务进行订单金额结算。支付功能本身并不收集您的个人信息，但我们需要将您的订单号与交易金额信息与支付机构（微信支付）共享以实现其确认您的支付指令并完成支付。</p>
        <h6>（二）为您提供以下附加功能服务</h6>
        <p>1、业务功能一：购物兑换积分</p>
        <p>为实现购物兑换积分功能，我们需要收集您的以下信息：荣耀会员码、交易和消费记录。其中交易和消费记录属于个人敏感信息，收集此类信息的目的是根据您的消费金额为您兑换相应积分。</p>
        <p>我们将按照以下方式使用您的个人信息：当您在Hi荣耀小程序商城或荣耀线下门店消费后，我们会获取您的交易和消费记录，并按一定的规则兑换成相应积分。</p>
        <p>如果您不提供这些信息，则无法将消费金额兑换成积分，但这并不会影响使用本服务的基本功能。</p>
        <p>2、业务功能二：积分兑换礼品</p>
        <p>为实现积分兑换礼品功能，我们需要收集您的以下信息：荣耀会员码、积分、个人位置。其中，个人位置信息属于个人敏感数据，收集此类信息的目的是记录您兑换礼品的门店。</p>
        <p>我们将按照以下方式使用您的个人信息：当您在荣耀线下门店使用积分兑换礼品时，我们将根据您的个人位置确定您兑换礼品的门店，按一定的规则消耗积分，并生成兑换记录。</p>
        <p>如果您不提供这些信息，则无法将积分兑换成礼品，但这并不会影响使用本服务的基本功能。</p>
        <p>3、业务功能三：会员等级优惠（晋级优惠券、积分翻倍、专属权益）</p>
        <p>为给不同等级的会员提供更好的服务，我们需要收集您的以下信息：荣耀会员码、会员积分、会员成长值。</p>
        <p>我们将按照以下方式使用您的个人信息：我们将根据您的会员成长值为您赠送晋级优惠券和其他不同等级会员的专属权益。</p>
        <p>如果您不提供这些信息，则无法享受高级别会员等级优惠，但这并不会影响使用本服务的基本功能。</p>
        <p>4、业务功能四：查找附近门店</p>
        <p>为实现查找附近门店功能，我们需要收集您的以下信息：个人位置信息，收集此类信息的目的是确认您的所在位置，为您准确推荐附近荣耀线下门店。</p>
        <p>我们将按照以下方式使用您的个人信息：根据您的个人位置信息为您显示您身边的荣耀线下门店信息。</p>
        <p>如果您不提供这些信息，则无法查找附近荣耀线下门店，但这并不会影响使用本服务的基本功能。</p>
        <h6>（三）从第三方服务提供商获取您的个人信息</h6>
        <p>我们将从微信获取您的头像、微信昵称、微信绑定手机号，用于呈现您的个人页面。</p>
        <p>当我们要将信息用于本声明未载明的其它用途时，会事先征求您的同意。</p>
        <p>当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
        <h6>二、向第三方服务提供商提供您的个人信息</h6>
        <p>（一）我们将向荣耀零售门店共享您的会员账号、会员等级和积分信息，以便在全国的授权门店都可以为您提供优质服务。</p>
        <p>（二）支付功能</p>
        <p>在您在荣耀线下门店购买商品，您可以通过微信支付所提供的支付服务进行订单金额结算。支付功能本身并不收集您的个人信息，但我们需要将您的订单号与交易金额信息与支付机构（微信支付）共享以实现其确认您的支付指令并完成支付。</p>
        <h6>三、用户画像及广告推送</h6>
        <p>我们可能根据您的以下个人信息进行分析和用户画像，以便向您提供更好的体验和个性化的服务，如姓名、职业、性别、生日、地址，您可以通过Hi荣耀小程序删除补充会员资料，关闭用户画像功能。</p>
        <h6>四、您的数据主体权利</h6>
        <p>在您使用荣耀微信会员服务期间，为了您可以更加便捷地访问、更正、删除您的个人信息，同时保障您撤回对个人信息使用的同意的权利，您可以访问隐私问题页面提交诉求。</p>
        <h6>（一）	访问个人信息</h6>
        <p>除法律法规规定外，您有权随时访问您的个人信息，可以通过点击微信卡包的荣耀会员卡查看您的会员信息。</p>
        <h6>（二）	删除和更新个人信息</h6>
        <p>可以访问隐私问题页面提交诉求，删除和更新，其他的个人信息</p>
        <h6>（三）撤回同意</h6>
        <p>每个业务功能往往需要收集一些基本的个人信息才能得以运营，对于您个人信息的收集和使用，您可以访问隐私问题页面要求撤回同意，或通过本声明中提供的方式自行操作。</p>
        <p>当您撤回同意后，我们后续将不再收集和使用您相应的个人信息，但请您理解，当您撤回同意或授权后，荣耀微信会员无法继续为您提供撤回同意或授权所对应的特定功能和/或服务。您撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
        <h6>（四）响应您的上述请求</h6>
        <p>为保障安全，我们可能会先要求您验证自己的身份，然后再处理您的请求。对于您的请求，我们原则上将于收到您的请求并在验证您用户身份后的三十日内做出答复。</p>
        <p>与法律法规要求相悖，或给国家、社会、荣耀、及其他组织或个人合法权益带来风险，或违背公序良俗的请求，我们可能会予以拒绝。</p>
        <p>如您对您的数据主体权利存在任何疑问、意见或建议，可通过隐私问题页面联系我们。</p>
        <h6>五、数据存储地点及期限</h6>
        <h6>（一）数据存储地点</h6>
        <p>我们在本服务项下收集和产生的个人信息，将存储在中华人民共和国境内。</p>
        <h6>（二）数据存储期限</h6>
        <p>我们仅为实现目的所必需的时间保留您的个人信息，并在超出前述保留时间后删除或匿名化处理您的个人信息，但法律法规另有要求的除外。</p>
        <p>在荣耀会员业务中，您的个人数据具体留存时间如下：</p>
        <p>会员注销后的两年内会保留会员相关信息，两年后无争议会删除会员相关信息。</p>
        <p>订单信息由于须遵守国家的税务、金融、财务相关法律规定，保存期为7年，订单信息包括您的姓名、手机号码、金额、产品SKU、收货地址、订单号、支付流水号、发票地址、物流单号、IP地址、邮箱、设备标识符、发货单号。当您在数据保留期内注销账号或主动删除订单时，此类交易数据只会在前台被删除，荣耀后台有权保留此类交易数据直到留存期结束。</p>
        <p>此外，当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</p>
        <h6>七、本声明如何更新</h6>
        <p>荣耀保留适时更新本声明的权利，且会及时在荣耀微信会员页面上更新，请及时留意。只有在获取您的同意后，我们才会按照更新后的声明收集、使用、存储您的个人信息。</p>
        <p>本声明自更新之日起生效。</p>
        <p>最近更新日期：【20190612】</p>
        <h6>重要提示：本隐私声明是关于荣耀微信会员在隐私方面的陈述与承诺，如您希望了解更多关于数据主体权利、信息安全措施等详细信息，请阅读《荣耀消费者业务隐私声明》。</h6>

    </div>
</template>

<script>
    export default {
        name: 'privateText',
        created(){
            document.querySelector('html').style.fontSize = '10px';
            document.title = "荣耀微信会员隐私声明";
        }
    }
</script>

<style>
    .pageWrapper {
        font-size: 1.4rem;
        padding: 10px;
    }
    .pageWrapper p, .pageWrapper h6 {
        text-indent: 2.8rem;
        margin: 5px;
    }
    .pageWrapper h6 {
        font-size: 1.4rem;
    }
    .textCenter {
        text-align: center;
    }
    .textBold {
        font-weight: bold;
    }
    .textIndent {
        text-indent: 2.8rem;
    }
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/privateText.vue